import FilterSection, { type FilterFacetItem } from './FilterSection'

export interface FilterSectionData<T = any> {
  [key: string]: FilterFacetItem<T>[]
}

interface FilterSectionsProps<TFilterValue = any, TFacetValue = any> {
  enableDeselectAllButton: boolean | Record<string, boolean>
  enableSelectAllButton?: Record<string, boolean>
  facets?: FilterSectionData<TFacetValue>
  filters?: FilterSectionData<TFilterValue>
  onDeselectSection: (
    sectionKey: string,
    sectionType: 'filter' | 'facet',
  ) => void
  onFacetToggle: (
    sectionKey: string,
    itemId: string | number,
    enabled: boolean,
  ) => void
  onFilterToggle: (
    sectionKey: string,
    itemId: string | number,
    enabled: boolean,
  ) => void
  onSelectSection?: (
    sectionKey: string,
    sectionType: 'filter' | 'facet',
  ) => void
  sectionTitles?: Record<string, string>
}

const FilterSections = <TFilterValue = any, TFacetValue = any>({
  filters,
  facets,
  enableDeselectAllButton,
  enableSelectAllButton,
  onFilterToggle,
  onFacetToggle,
  onDeselectSection,
  onSelectSection,
  sectionTitles,
}: FilterSectionsProps<TFilterValue, TFacetValue>) => (
  <>
    {filters &&
      Object.entries(filters).map(([sectionKey, items]) => (
        <FilterSection
          enableDeselectAllButton={
            typeof enableDeselectAllButton === 'boolean'
              ? enableDeselectAllButton
              : (enableDeselectAllButton?.[sectionKey] ??
                enableDeselectAllButton?.['*'] ??
                false)
          }
          enableSelectAllButton={enableSelectAllButton?.[sectionKey] || false}
          items={items}
          key={`filter-${sectionKey}`}
          sectionKey={sectionKey}
          sectionTitle={sectionTitles?.[sectionKey]}
          sectionType="filter"
          toggleHandler={onFilterToggle}
          onDeselectSection={onDeselectSection}
          onSelectSection={onSelectSection}
        />
      ))}
    {facets &&
      Object.entries(facets).map(([sectionKey, items]) => (
        <FilterSection
          enableDeselectAllButton={
            typeof enableDeselectAllButton === 'boolean'
              ? enableDeselectAllButton
              : (enableDeselectAllButton?.[sectionKey] ??
                enableDeselectAllButton?.['*'] ??
                false)
          }
          enableSelectAllButton={enableSelectAllButton?.[sectionKey] || false}
          items={items}
          key={`facet-${sectionKey}`}
          sectionKey={sectionKey}
          sectionTitle={sectionTitles?.[sectionKey]}
          sectionType="facet"
          toggleHandler={onFacetToggle}
          onDeselectSection={onDeselectSection}
          onSelectSection={onSelectSection}
        />
      ))}
  </>
)

export default FilterSections
